import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-wrapper --auth-layout" }
const _hoisted_2 = { class: "main-row" }
const _hoisted_3 = { class: "main-container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "main-slot" }

import { useStore } from "@/store";
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AuthLayout',
  setup(__props) {

const store = useStore();
const isLogoHidden = computed(() => store.state.system.isLogoHidden);

const configDataDefaultBrand = computed(
  () => store.getters["brand/configDataDefaultBrand"]
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("aside", {
          class: _normalizeClass([{ '--hide-mobile': isLogoHidden.value }, "main-header"])
        }, [
          _createElementVNode("img", {
            class: "main-header__logo",
            src: configDataDefaultBrand.value.assets.logo,
            alt: "Логотип"
          }, null, 8, _hoisted_4),
          _createElementVNode("img", {
            class: "main-header__logo_mobile",
            src: configDataDefaultBrand.value.assets.mobileLogo,
            alt: "Логотип"
          }, null, 8, _hoisted_5)
        ], 2), [
          [_vShow, !_unref(store).state.system.isAsideHidden]
        ]),
        _createElementVNode("main", _hoisted_6, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ])
  ]))
}
}

})